import { useState, useEffect } from "react";
import api from "@/lib/api";

let _cache = null;
const _subs = new Set();

export function refreshFlags() {
  return api.get("/feature-flags").then((r) => {
    _cache = r.data;
    _subs.forEach((fn) => fn(r.data));
    return r.data;
  }).catch(() => {});
}

export function useFlags() {
  const [flags, setFlags] = useState(_cache || { v2_enabled: false, v3_enabled: false, v4_enabled: false });
  useEffect(() => {
    _subs.add(setFlags);
    if (_cache) setFlags(_cache); else refreshFlags();
    return () => { _subs.delete(setFlags); };
  }, []);
  return flags;
}
